import React from 'react';

const JHLogo = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 309 80"
    // style="enable-background:new 0 0 309 80;"
    style={{ enableBackground: 'new 0 0 309 80' }}
    xmlSpace="preserve"
  >
    <style
      type="text/css"
      dangerouslySetInnerHTML={{
        __html: `
  .st0{fill:#231F20;}
  .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#009346;} 
`,
      }}
    >
      {/* .st0{fill:#231F20;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#009346;} */}
    </style>
    <g>
      <path
        className="st0"
        d="M97.4,42.8c0,6.2-2.8,8.7-8.5,8.7s-8.3-3.2-8.3-8.2v-1.9h6.3v1.3c0,1.8,0,3.4,1.9,3.4s1.7-2.2,1.7-3.2V28.3h7
		V42.8L97.4,42.8z"
      />
      <path
        className="st0"
        d="M116.3,47.3c0,1.2,0.1,2.6,0.8,3.7h-6.4c-0.2-0.5-0.2-1.1-0.2-1.6h-0.1c-1.3,1.5-3.3,2-5.3,2
		c-3.2,0-5.8-1.5-5.8-5c0-5.2,6.1-5,9.3-5.6c0.9-0.2,1.7-0.4,1.7-1.5c0-1.1-1.1-1.5-2.1-1.5c-1.9,0-2.3,1-2.3,1.7h-5.8
		c0.2-4.6,4.6-5.4,8.5-5.4c7.9,0,7.8,3.3,7.8,6.5L116.3,47.3L116.3,47.3z M110.3,43.6c-0.8,0.4-1.6,0.6-2.5,0.8
		c-1.4,0.3-2.1,0.7-2.1,1.8c0,0.8,0.8,1.5,2,1.5c1.4,0,2.5-0.9,2.6-2.6V43.6z"
      />
      <path
        className="st0"
        d="M119.6,34.5h6.1v2.2h0.1c1.3-1.9,3.1-2.6,5.4-2.6c1.8,0,3.7,0.9,4.4,2.6c0.2-0.2,1.5-2.6,5.6-2.6
		s5.6,2.9,5.6,5.6V51h-6.3v-8.9c0-1.6-0.2-2.9-2.1-2.9c-1.6,0-2.1,1.2-2.1,2.9V51h-6.3v-8.9c0-1.6-0.2-2.9-2.1-2.9
		c-1.6,0-2.1,1.2-2.1,2.9V51h-6.3V34.5z"
      />
      <path
        className="st0"
        d="M155.1,44.2c0.2,1.9,1.2,3.2,3.2,3.2c1,0,2.1-0.4,2.6-1.2h5.9c-1.3,3.6-4.7,5.2-8.5,5.2
		c-5.3,0-9.2-3.1-9.2-8.6c0-4.8,3.5-8.7,8.7-8.7c6.5,0,9.4,3.7,9.4,10.1L155.1,44.2L155.1,44.2z M161.2,40.9c0-1.5-1.1-2.8-2.8-2.8
		c-1.9,0-2.9,1-3.2,2.8H161.2z"
      />
      <path
        className="st0"
        d="M179,39.3c0-0.5-0.3-1-0.7-1.2c-0.4-0.3-0.9-0.5-1.4-0.5c-0.9,0-1.9,0.2-1.9,1.3c0,0.5,0.4,0.7,0.7,0.9
		c1.1,0.4,3.4,0.6,5.5,1.3c2.1,0.7,3.9,1.9,3.9,4.6c0,4.6-4.4,5.8-8.4,5.8s-8.1-1.6-8.2-5.8h6c0,0.6,0.3,1,0.8,1.5
		c0.3,0.3,0.9,0.5,1.7,0.5c0.8,0,2.1-0.3,2.1-1.3s-0.5-1.2-3.5-1.8c-4.8-0.8-6.7-2.4-6.7-5.2c0-4.2,4.5-5.2,7.8-5.2
		c3.6,0,7.8,1,8,5.2H179z"
      />
      <path
        className="st0"
        d="M187.4,28.3h7v7.9h6.5v-7.9h7V51h-7v-9h-6.5v9h-7V28.3z"
      />
      <path
        className="st0"
        d="M226.8,47.3c0,1.2,0.1,2.6,0.8,3.7h-6.4c-0.2-0.5-0.2-1.1-0.2-1.6h-0.1c-1.3,1.5-3.3,2-5.3,2
		c-3.2,0-5.8-1.5-5.8-5c0-5.2,6.1-5,9.3-5.6c0.9-0.2,1.7-0.4,1.7-1.5c0-1.1-1.1-1.5-2.1-1.5c-1.9,0-2.3,1-2.4,1.7h-5.8
		c0.2-4.6,4.6-5.4,8.5-5.4c7.9,0,7.8,3.3,7.8,6.5L226.8,47.3L226.8,47.3z M220.8,43.6c-0.8,0.4-1.6,0.6-2.5,0.8
		c-1.4,0.3-2.1,0.7-2.1,1.8c0,0.8,0.8,1.5,2,1.5c1.4,0,2.5-0.9,2.6-2.6V43.6z"
      />
      <path
        className="st0"
        d="M229.8,34.5h6v2.6h0.1c1-2,2.4-3,4.6-3c0.6,0,1.2,0.1,1.8,0.2v5.6c-0.6-0.2-1.2-0.4-2.5-0.4
		c-2.5,0-3.8,1.5-3.8,5V51h-6.3L229.8,34.5L229.8,34.5z"
      />
      <path
        className="st0"
        d="M260.9,51h-6.1v-1.8h-0.1c-0.8,1-1.8,2.2-4.8,2.2c-4.7,0-6.9-4.6-6.9-8.7c0-3.9,1.5-8.6,7-8.6
		c1.9,0,3.6,0.8,4.5,2.2h0.1v-8h6.3L260.9,51L260.9,51z M252.1,38.7c-2.3,0-2.8,2.1-2.8,4.1c0,1.9,0.5,4.1,2.8,4.1s2.8-2.1,2.8-4.1
		C254.8,40.8,254.3,38.7,252.1,38.7z"
      />
      <path
        className="st0"
        d="M270,31.5v1.3h-6.3v-4.4h6.3V31.5z M263.7,34.5h6.3V51h-6.3V34.5z"
      />
      <path
        className="st0"
        d="M278.2,44.2c0.2,1.9,1.2,3.2,3.2,3.2c1,0,2.1-0.4,2.6-1.2h5.9c-1.3,3.6-4.7,5.2-8.5,5.2
		c-5.3,0-9.2-3.1-9.2-8.6c0-4.8,3.5-8.7,8.7-8.7c6.5,0,9.4,3.7,9.4,10.1L278.2,44.2L278.2,44.2z M284.2,40.9c0-1.5-1.1-2.8-2.8-2.8
		c-1.9,0-3,1-3.2,2.8H284.2z"
      />
    </g>
    <path
      className="st1"
      d="M40.9,11C25,11,12,24,12,39.9s13,28.9,28.9,28.9s28.9-12.9,28.9-28.9S56.9,11,40.9,11z M38.8,63.6l4-12.3h5.3
	l-4,12.2c-1.1,0.2-2.2,0.2-3.3,0.2C40.2,63.7,39.5,63.7,38.8,63.6L38.8,63.6z M51.4,61.3l9.3-28.5h-6.4l-4,12.4h-5.4l4-12.4h-6.4
	l-9.6,29.5C23.7,59,17.1,50.2,17.1,39.9c0-12.1,9-22,20.6-23.6l-7.5,23.1C30,40.4,29,40.9,28,40.6c-0.9-0.3-1.4-1.3-1.1-2.2l1.8-5.6
	h-6.4l-1.2,3.7c-1.3,4.1,0.9,8.6,5.1,9.9s8.6-0.9,9.9-5.1l8.1-25C55.8,18,64.7,27.9,64.7,39.9C64.7,49.3,59.3,57.4,51.4,61.3
	L51.4,61.3z"
    />
    <g>
      <path
        className="st0"
        d="M291.2,26.8h-0.9v-0.4h2.5v0.4h-0.9v2.7h-0.6C291.2,29.5,291.2,26.8,291.2,26.8z"
      />
      <path
        className="st0"
        d="M293.1,26.4h1l0.7,2.3h0l0.7-2.3h0.9v3.1h-0.6v-2.6h0l-0.8,2.6h-0.5l-0.8-2.6h0v2.6h-0.6L293.1,26.4
		L293.1,26.4z"
      />
    </g>
  </svg>
  // <svg
  //   version="1.1"
  //   id="Layer_1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   x="0px"
  //   y="0px"
  //   viewBox="0 0 286.7 87.31"
  // >
  //   <g>
  //     <path
  //       fill="#00833E"
  //       d="M88.1,46.53c0,6.18-2.79,8.59-8.4,8.59c-5.68,0-8.22-3.17-8.22-8.06v-1.88h6.21v1.29c0,1.72,0,3.32,1.85,3.32
  // 	c1.79,0,1.66-2.16,1.66-3.17V32.2h6.9V46.53z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M106.8,50.95c0,1.22,0.06,2.6,0.75,3.64h-6.33c-0.16-0.44-0.25-1.1-0.22-1.54h-0.06
  // 	c-1.32,1.5-3.23,1.94-5.24,1.94c-3.14,0-5.74-1.51-5.74-4.92c0-5.14,6.02-4.95,9.19-5.55c0.85-0.16,1.69-0.41,1.69-1.44
  // 	c0-1.1-1.03-1.5-2.04-1.5c-1.91,0-2.29,0.97-2.32,1.66h-5.77c0.19-4.58,4.52-5.33,8.37-5.33c7.78,0,7.71,3.23,7.71,6.37V50.95z
  // 	 M100.84,47.28c-0.75,0.38-1.6,0.6-2.45,0.78c-1.38,0.31-2.1,0.66-2.1,1.76c0,0.75,0.82,1.5,1.94,1.5c1.41,0,2.51-0.85,2.6-2.54
  // 	V47.28z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M110.06,38.31h5.99v2.16h0.06c1.25-1.88,3.07-2.57,5.33-2.57c1.76,0,3.64,0.91,4.39,2.54
  // 	c0.25-0.19,1.5-2.54,5.55-2.54c4.17,0,5.58,2.88,5.58,5.52v11.16h-6.21v-8.81c0-1.54-0.16-2.92-2.04-2.92
  // 	c-1.57,0-2.1,1.22-2.1,2.92v8.81h-6.21v-8.81c0-1.54-0.16-2.92-2.04-2.92c-1.57,0-2.1,1.22-2.1,2.92v8.81h-6.21V38.31z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M145.11,47.84c0.16,1.85,1.22,3.17,3.17,3.17c1,0,2.1-0.38,2.6-1.16h5.8c-1.25,3.51-4.67,5.14-8.37,5.14
  // 	c-5.2,0-9.12-3.07-9.12-8.5c0-4.74,3.45-8.59,8.59-8.59c6.46,0,9.25,3.61,9.25,9.94H145.11z M151.07,44.61
  // 	c0-1.5-1.13-2.73-2.73-2.73c-1.85,0-2.92,0.97-3.2,2.73H151.07z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M168.63,43.05c-0.03-0.53-0.31-0.94-0.72-1.22c-0.38-0.31-0.88-0.47-1.38-0.47c-0.88,0-1.88,0.19-1.88,1.25
  // 	c0,0.47,0.38,0.69,0.72,0.85c1.03,0.44,3.39,0.56,5.45,1.25c2.07,0.66,3.89,1.88,3.89,4.55c0,4.51-4.33,5.74-8.28,5.74
  // 	c-3.83,0-8.03-1.54-8.12-5.74h5.93c0.03,0.56,0.28,1.03,0.75,1.44c0.31,0.28,0.91,0.47,1.66,0.47c0.82,0,2.1-0.31,2.1-1.25
  // 	c0-0.94-0.53-1.22-3.42-1.72c-4.73-0.82-6.65-2.32-6.65-5.11c0-4.11,4.42-5.17,7.68-5.17c3.51,0,7.74,0.97,7.9,5.14H168.63z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M176.91,32.2h6.9v7.78h6.46V32.2h6.9v22.39h-6.9v-8.87h-6.46v8.87h-6.9V32.2z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M215.85,50.95c0,1.22,0.06,2.6,0.75,3.64h-6.33c-0.16-0.44-0.25-1.1-0.22-1.54h-0.06
  // 	c-1.32,1.5-3.23,1.94-5.24,1.94c-3.13,0-5.74-1.51-5.74-4.92c0-5.14,6.02-4.95,9.19-5.55c0.85-0.16,1.69-0.41,1.69-1.44
  // 	c0-1.1-1.03-1.5-2.04-1.5c-1.91,0-2.29,0.97-2.32,1.66h-5.77c0.19-4.58,4.52-5.33,8.37-5.33c7.78,0,7.71,3.23,7.71,6.37V50.95z
  // 	 M209.89,47.28c-0.75,0.38-1.6,0.6-2.45,0.78c-1.38,0.31-2.1,0.66-2.1,1.76c0,0.75,0.81,1.5,1.94,1.5c1.41,0,2.51-0.85,2.6-2.54
  // 	V47.28z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M218.83,38.31h5.96v2.6h0.06c1-1.94,2.32-3.01,4.58-3.01c0.63,0,1.22,0.09,1.82,0.25v5.49
  // 	c-0.63-0.22-1.19-0.41-2.44-0.41c-2.45,0-3.76,1.44-3.76,4.92v6.43h-6.21V38.31z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M249.53,54.58h-5.99V52.8h-0.06c-0.78,1.03-1.72,2.2-4.77,2.2c-4.61,0-6.84-4.55-6.84-8.62
  // 	c0-3.82,1.47-8.47,6.93-8.47c1.85,0,3.51,0.82,4.45,2.19h0.06v-7.9h6.21V54.58z M240.81,42.42c-2.23,0-2.73,2.1-2.73,4.01
  // 	c0,1.94,0.5,4.04,2.73,4.04c2.23,0,2.73-2.1,2.73-4.04C243.54,44.52,243.03,42.42,240.81,42.42z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M258.46,35.31v1.24h-6.21V32.2h6.21V35.31z M252.25,38.31h6.21v15.03v1.24h-6.21V38.31z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M266.61,47.84c0.16,1.85,1.22,3.17,3.17,3.17c1,0,2.1-0.38,2.6-1.16h5.8c-1.25,3.51-4.67,5.14-8.37,5.14
  // 	c-5.2,0-9.12-3.07-9.12-8.5c0-4.74,3.45-8.59,8.59-8.59c6.46,0,9.25,3.61,9.25,9.94H266.61z M272.57,44.61
  // 	c0-1.5-1.13-2.73-2.73-2.73c-1.85,0-2.91,0.97-3.2,2.73H272.57z"
  //     />
  //   </g>
  //   <g>
  //     <g>
  //       <g>
  //         <path
  //           className="st1"
  //           fill="#00833E"
  //           d="M32.34,15.11c-15.77,0-28.55,12.78-28.55,28.55c0,15.77,12.78,28.55,28.55,28.55
  // 			c15.77,0,28.55-12.78,28.55-28.55C60.89,27.89,48.11,15.11,32.34,15.11z M30.29,67.04l3.95-12.17h5.28L35.62,66.9
  // 			c-1.07,0.15-2.17,0.23-3.28,0.23C31.65,67.13,30.97,67.1,30.29,67.04z M42.68,64.74l9.15-28.16h-6.36l-3.98,12.26h-5.29
  // 			l3.98-12.26h-6.36l-9.48,29.16C15.32,62.47,8.87,53.82,8.87,43.66c0-11.92,8.88-21.76,20.38-23.27L21.84,43.2
  // 			c-0.3,0.92-1.28,1.42-2.2,1.12c-0.92-0.3-1.42-1.29-1.12-2.2l1.8-5.54h-6.36l-1.19,3.67c-1.33,4.1,0.91,8.49,5,9.82
  // 			c4.09,1.33,8.49-0.91,9.82-5l8.01-24.66c11.42,1.59,20.22,11.39,20.22,23.25C55.82,52.91,50.46,60.91,42.68,64.74z"
  //         />
  //       </g>
  //     </g>
  //   </g>
  //   <g>
  //     <path
  //       fill="#00833E"
  //       d="M279.44,30.7h-0.91v-0.41h2.41v0.41h-0.89v2.64h-0.61V30.7z"
  //     />
  //     <path
  //       fill="#00833E"
  //       d="M281.29,30.29h0.95l0.67,2.26h0.01l0.66-2.26h0.93v3.05h-0.58V30.8h-0.01l-0.77,2.54h-0.51l-0.77-2.54h-0.01
  // 	v2.54h-0.58V30.29z"
  //     />
  //   </g>
  // </svg>
);

export default JHLogo;
